    import React, { useState } from 'react';
    import { useNavigate } from 'react-router-dom';
    import { Button } from './ui/button';
    import { Skull, Play } from 'lucide-react';
    import homePageImg from '../assets/data/home page/forest.jpg'
    import { getGameProgress } from '../data/mock';

    const HomePage = () => {
      const navigate = useNavigate();
       const [isRegistering, setIsRegistering] = useState(false);

    const handleStart = async () => {
        setIsRegistering(true);
        try {
          // Replace with your actual API endpoint for user registration
          const response = await fetch('/server/JurassicServer/registerUser', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            // You can send any user data if needed, e.g.:
            // body: JSON.stringify({ username: 'new-agent' }),
          });
          if (!response.ok) {
            // Handle API errors (e.g., show an error message)
            throw new Error('User registration failed');
          }

          // Start loading challenges in background (don't await - fire and forget)
          getGameProgress().catch(err => console.error('Error preloading challenges:', err));

          // On successful registration, proceed to the intro
          navigate('/instructions');
        } catch (error) {
          console.error('Failed to start mission:', error);
          // Optional: Display an error message to the user
          // For now, we'll navigate anyway to not block the user
          navigate('/instructions');
        } finally {
          setIsRegistering(false);
        }
      }

      return (
        <div
          className="min-h-screen flex flex-col items-center justify-center relative text-white p-4"
          style={{
            backgroundImage: `url(${homePageImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/15 z-0"></div>

          {/* Main content */}
          <div className="relative z-10 flex flex-col items-center justify-center text-center">
            <div className="flex items-center justify-center mb-6">
                <Skull className="w-16 h-16 text-red-500 animate-bounce" />
            </div>
            {/* Game Logo */}
            <div className="mb-8 transform transition-transform duration-300 ease-in-out hover:scale-105">
              <h2
                className="text-7xl md:text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-600"
                style={{ fontFamily: `'Cinzel', serif`, textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}
              >
                The Great Deluge
              </h2>
              <h2
                className="text-7xl md:text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-600"
                style={{ fontFamily: `'Cinzel', serif`, textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}
              >
                Dino Hunt
              </h2>
            </div>

            {/* Game description */}
            <div className="max-w-2xl text-center mb-12 bg-black/50 backdrop-blur-sm rounded-lg p-6 border border-gray-700/50">
              <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
                Seven dinosaurs have escaped their enclosures.
                <br />
                <span className="text-yellow-400 font-semibold">Your mission: Capture them all.</span>
                <br />
                Solve Deluge challenges to unlock weapons and save DRE.
              </p>
            </div>


            {/* Start button */}
            <Button
              onClick={handleStart}
              size="lg"
              className="text-2xl px-12 py-8 bg-green-800/80 hover:bg-green-700/90 text-white font-bold rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300 border-2 border-green-600/80"
              disabled={isRegistering}
           >
              {isRegistering ? (
                <>
                 <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Registering...
                </>
              ) : (
                <>
                  <Play className="w-8 h-8 mr-3" />
                  BEGIN HUNT
                </>
              )}
            </Button>

            {/* Footer warning */}
            <div className="mt-16 text-center">
              <p className="text-red-500 text-sm md:text-base font-semibold animate-pulse">
                WARNING: You have one hour to complete the hunt. The clock is ticking...
              </p>
            </div>
          </div>
        </div>
      );
    };

    export default HomePage;
